import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSiteContent } from '../contexts/SiteContentContext';

// The announcement strip under the nav, set in the admin portal. Dismissing hides that message for the visit.
export default function SiteBanner() {
  const { content } = useSiteContent();
  const { enabled, text, link_label: linkLabel, link_url: linkUrl } = content.banner || {};
  const [dismissed, setDismissed] = useState(null);

  if (!enabled || !text || dismissed === text) return null;

  const link = linkUrl && linkLabel
    ? (linkUrl.startsWith('/')
      ? <Link to={linkUrl} className="site-banner-link">{linkLabel}</Link>
      : <a href={linkUrl} className="site-banner-link" target="_blank" rel="noopener noreferrer">{linkLabel}</a>)
    : null;

  return (
    <div className="site-banner" role="status">
      <div className="site-banner-inner">
        <p>{text}{link && <> {link}</>}</p>
        <button type="button" className="site-banner-close" aria-label="Dismiss announcement" onClick={() => setDismissed(text)}>
          <span aria-hidden="true">×</span>
        </button>
      </div>
    </div>
  );
}
